module.exports = __webpack_public_path__ + "static/media/traffic-cone.3338af93.svg";